import { isStandalone } from '@repo/detection';

export const urlParams = new URLSearchParams(
  typeof window === 'undefined' ? undefined : window?.location?.search
);
export const TEMPLATE_PARAM = 'tid';
export const FEED_INDEX_PARAM = 'feedIndex';
export const FEATURE_ORIGIN_PARAM = 'featureOrigin';
export const UPDATE_TEMPLATE_PARAM = 'utid';
export const NEW_DESIGN_TEMPLATE_PARAM = 'ndtid';
export const DESIGN_PARAM = 'did';
export const NEW_DESIGN_PARAM = 'nd';
export const NEW_DESIGN_WITH_OBJECT_PARAM = 'ndo';
export const NEW_DESIGN_WITH_TEXT_OBJECT_PARAM = 'ndt';
export const SHARE_PARAM = 'sid';
export const PROMO_CODE = 'promocode';
export const FOLDER_PARAM = 'fid';
export const WORKSPACE_PARAM = 'wid';
export const NEW_DESIGN_CATEGORY_PARAM = 'ndc';
export const ONBOARDING_SKIP_PARAM = 'noo';
export const UPDATE_MOCKUP_TEMPLATE_PARAM = 'umtid';
export const AI_TOOLS_PARAM = 'at';
export const AI_USE_CASE_GENERATOR_PARAM = 'aiucg';
export const USE_CASE_PARAM = 'useCase';
export const SUB_USE_CASE_PARAM = 'subUseCase';
export const TEMPLATE_CATEGORY_PARAM = 'tc';
export const TEMPLATE_SEARCH_QUERY = 'tsq';
export const OPEN_TEMPLATE_SEARCH_PANEL = 'otsp';
export const RELATED_VIEW_PARAM = 'relatedView';
export const ORIGIN_PARAM = 'origin';
export const GENERATION_TAG_PARAM = 'generationTag';
export const GENERATION_LAYOUT_GROUPS_PARAM = 'layoutGroups';
export const UPLOAD_FILE_PARAM = 'uf';
export const LIBRARIES_PARAM = 'brandKits';
export const MOCKUPS_GROUP_ID_PARAM = 'mgid';
export const MOCKUP_ID = 'mid';
export const TEST_AI_DESIGN_GENERATED_ID = 'test_dgid'; // Given a design id, it loads the design in the canvas using the aiDesignGen logic
export const COLLAB_LINK_SHARE_TRACKING = 'clst';

export const CURRENT_ARTBOARD_ID = 'artboardId';
export const ACTIVE_THREAD_ID = 'threadId';

// we can remove this once all older links are redeemed / expired
export const LEGACY_INVITE_ID = 'inviteid';
export const INVITE_ID = 'inviteId';

export function openNewWindowWithParams(
  paramOrParams: string | Record<string, string>,
  paramValue?: string,
  isMobile?: boolean
): void {
  const url = new URL(window.location.origin);
  if (typeof paramOrParams === 'string') {
    url.searchParams.append(paramOrParams, paramValue!);
  } else {
    Object.entries(paramOrParams).forEach(([param, value]) => {
      url.searchParams.append(param, value);
    });
  }
  // when in standalone or in mobile mode, we want to open the url in the same window
  // Some browsers block the open in a new window or tab, so we use the same tab instead
  if (isStandalone() || isMobile) {
    window.location.href = url.toString();
  } else {
    window.open(url, '_blank');
  }
}

/**
 * This function is used to get a parameter from the url in a case insensitive way.
 * @param param - The parameter to get
 * @returns The value of the parameter or undefined
 */
export function getCaseInsensitiveParam(
  param: string,
  urlParams: URLSearchParams
): string | undefined {
  return [...urlParams.entries()].find(([key]) => {
    return key.toLowerCase() === param.toLowerCase();
  })?.[1];
}
